import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrendBoard from "./components/TrendBoard";
import CatSections from "./components/CatSections";
import FeatureBoard from "./components/FeatureBoard";
import Newsline from "./components/Newsline";
import AboutWall from "./components/AboutWall";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <TrendBoard />
        <CatSections />
        <FeatureBoard />
        <Newsline />
        <AboutWall />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}